import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


/**------------------------------------------------------
 * Convert the HTML to SafeHtml
 * ----------------------------
 * Usage:
 * 	value (string type) | ngSafeHTML
 * Example:
 * 	{{ text | ngSafeHTML }}
 * 	Converts the passed html to safeHTML
 */
@Pipe({
    name: 'ngSafeHTML',
    standalone: false
})
export class NgSafeHtmlPipe implements PipeTransform {

	constructor(
		protected sanitizer: DomSanitizer
	) {}

	transform(value: string): SafeHtml {
		return this.sanitizer.bypassSecurityTrustHtml(value);
	}
}
